import { styled } from "styled-components";
import React, { useEffect } from "react";
import { IconButton, LeadText } from "@gnist/design-system";
import { tokens } from "@gnist/themes/tokens.css.js";

const Dialog = styled.div`
  background-color: ${tokens.color.background};
  color: ${tokens.color["on-surface"]};
  position: relative;
  height: 100dvh;
  width: 100vw;
  box-sizing: border-box;
  overflow: auto;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: ${tokens.spacing.l} ${tokens.spacing.xl} 0;
  margin-bottom: calc(${tokens.spacing.xxl} * 3);
`;

const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: sticky;
  top: 0;
  padding: ${tokens.spacing.xl} ${tokens.spacing.xl} ${tokens.spacing.xs};
  background-color: ${tokens.color.background};
  z-index: 1;
`;

const Title = styled(LeadText)`
  font-size: ${tokens.typeface.size.base};
  font-weight: ${tokens.typeface.weight.regular};
`;

export const Wrapper = styled.div`
  position: fixed;
  z-index: 1300;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  handleGoBack: () => void;
  hasParentCategory: boolean;
  headingText: string;
  children: React.ReactNode;
}

export const FilterModal = ({
  isOpen,
  handleClose,
  handleGoBack,
  hasParentCategory,
  headingText,
  children,
}: Props) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  return (
    <Wrapper style={{ display: isOpen ? "flex" : "none" }}>
      <Dialog>
        <div>
          <HeaderRow>
            {hasParentCategory && (
              <IconButton
                icon={"arrow_backward"}
                label={"Go back"}
                onClick={handleGoBack}
              />
            )}
            <Title>{headingText}</Title>
            <IconButton
              icon="close"
              onClick={handleClose}
              label={"close modal"}
              autoFocus
            />
          </HeaderRow>
          <ContentContainer>{children}</ContentContainer>
        </div>
      </Dialog>
    </Wrapper>
  );
};
